//#region [IMPORT]

//=== API ===
import { sendMessage, emit, setFocusedImage } from "api/prokey/prokey.websocket";

//#endregion


//-----------------------------------------------------------------
export function setMainField( field ) {
  //-----------------------------------------------------------------
  emit( 'FIELD-FOCUS-' + field.id );
  emit( 'FIELD-FOCUS', field );
  setFocusedImage( field.image );
}

//-----------------------------------------------------------------
export function requestFieldFocus( field_id ) {
  //-----------------------------------------------------------------
  const message = { type: 'ANALYTICS-FIELD-FOCUS-REQUEST', data: { id: field_id } };
  sendMessage( JSON.stringify( message ) );
}